<template>
  <div id="pageTable">
    <v-container grid-list-xl>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field

                flat
                hide-details
                :placeholder="$t('search')"
                prepend-icon="search"
                solo
                v-model="search"
              ></v-text-field>
              <v-btn small color="primary" @click="sendEmit('create')">{{$t('new')}}</v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :expand="expand"
                :headers="complex.headers"
                :items="formatList"
                :rows-per-page-items="[10,25,50,{text:'All','value':-1}]"
                :search="search"
                class="elevation-1"
                item-key="_id"
                :loading="loading"
                :pagination.sync="pagination"
              >
                <template slot="items" slot-scope="props">
                  <td class="text-xs-center px-0">
                    <v-btn flat icon color="primary" small class="px-0 mx-0">
                      <v-icon
                        class="icon material-icons"
                        @click="sendEmit('clone', props.item._id)"
                      >file_copy</v-icon>
                    </v-btn>
                    <v-btn flat icon color="success" small class="px-0 mx-0">
                      <v-icon
                        class="icon material-icons"
                        @click="sendEmit('update', props.item._id)"
                      >create</v-icon>
                    </v-btn>
                    <v-btn flat icon color="error" small class="px-0 mx-0">
                      <v-icon
                        class="icon material-icons"
                        @click="sendEmit('delete', props.item._id)"
                      >delete</v-icon>
                    </v-btn>
                  </td>
                  <td>
                    <i
                      class="success--text icon material-icons"
                      v-if="props.item.active"
                    >check_circle</i>
                    <i class="error--text icon material-icons" v-else>cancel</i>
                  </td>
                  <td>{{ props.item.name }}</td>
                  <td>{{props.item.type}}</td>
                  <td @click="props.expanded = !props.expanded" class="cursor">
                    <i class="icon material-icons">visibility</i>
                  </td>
                  <td>{{props.item.createdAt}}</td>
                  <td>{{ props.item.createdBy }}</td>
                  <td>{{props.item.updatedAt}}</td>
                  <td>{{ props.item.updatedBy }}</td>
                </template>
                <template slot="expand" slot-scope="props">
                  <v-container class="line-bottom text-left" grid-list-md text-xs-center>
                    <v-layout row wrap>
                      <v-flex
                        :key="index"
                        v-for="(item, index) in getNamePermission(props.item.permissions)"
                        xs3
                      >
                        <p>
                          <i class="icon material-icons">done_all</i>
                          {{item}}
                        </p>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="dialog" max-width="290">
      <v-card>
        <v-card-title class="headline">Confirme Clonacion</v-card-title>

        <v-card-text>¿Realmente desea clonar este rol?</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="primary darken-1" flat="flat" @click="yesClone()">Confirmar</v-btn>

          <v-btn color="error darken-1" flat="flat" @click="noClone()">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { dateFormat } from '../../../helpers/dateHelper'

export default {
  name: 'listRols',
  data () {
    return {
      isClone: null,
      expand: false,
      search: '',
      pagination: {
        sortBy: 'active',
        descending: true
      },
      complex: {
        headers: [
          {
            text: this.$t('actions'),
            value: ''
          },
          {
            text: this.$t('state'),
            value: 'active'
          },
          {
            text: this.$t('name'),
            value: 'name'
          },
          {
            text: this.$t('type'),
            value: 'type'
          },
          {
            text: this.$t('permissions'),
            value: 'permissions'
          },
          {
            text: this.$t('createdAt'),
            value: 'createdAt'
          },
          {
            text: this.$t('createdBy'),
            value: 'createdBy'
          },
          {
            text: this.$t('updatedAt'),
            value: 'updatedAt'
          },
          {
            text: this.$t('updatedBy'),
            value: 'updatedBy'
          }

        ]
      }
    }
  },
  computed: {
    ...mapState({
      listing: state => state.rols.list,
      listUser: state => state.users.listaUsers,
      loading: state => state.rols.loading,
      interRol: state => state.rols.selected
    }),
    formatList () {
      return this.listing.map(role => {
        return {
          ...role,
          type: this.rolType(role.type),
          createdAt: dateFormat(role.createdAt),
          createdBy: this.formatUser(role.createdBy),
          updatedAt: dateFormat(role.updatedAt),
          updatedBy: this.formatUser(role.updatedBy)
        }
      })
    },
    dialog () {
      return (this.isClone !== null)
    }
  },
  methods: {
    ...mapActions({
      getOne: 'rols/setOne',
      setClone: 'rols/setClone'
    }),
    rolType (rol) {
      switch (rol) {
        case 'entities':
          return this.$tc('entity')
        case 'teams':
          return this.$tc('team')
        case 'participant':
          return this.$t('participant')
        case 'tournaments':
          return this.$tc('tournament')
        case 'matches':
          return this.$tc('match')
        case 'users':
          return this.$tc('user')
        case 'all':
          return this.$t('admin')
      }
    },
    getNamePermission (permissions) {
      let result = []
      permissions.forEach(item => result.push(item.name))
      return result
    },
    sendEmit (evento, id = null) {
      if (evento !== 'delete' && evento !== 'create' && evento !== 'update' && evento !== 'clone') {
        return
      }
      switch (evento) {
        case 'create':
          this.$emit('create')
          break
        case 'update':
          this.getOne(id)
          this.$emit('update')
          break
        case 'delete':
          this.getOne(id)
          this.$emit('remove')
          break
        case 'clone':
          this.getOne(id)
          this.isClone = id
          break
      }
    },
    noClone () {
      this.isClone = null
    },
    yesClone () {
      if (this.isClone) { this.setClone(this.interRol) }
      this.isClone = null
    }
  }
}
</script>
<style scoped>
.cursor {
  cursor: pointer;
}

.line-bottom {
  border-bottom: 1px solid #000;
}

.text-left {
  text-align: left;
}

.success--text {
  color: green;
}

.error--text {
  color: red;
}
</style>
